import { showErrorToast } from "@stadium/services/react-toastify";
import startCase from "lodash/startCase";

export const formatErrors = (error) => {
  const errorArr = error?.meta?.errors || error?.errors || [];
  let errors = errorArr.map(({ detail, source }) => {
    const keyArr = source?.pointer?.split("/");
    const key = keyArr[keyArr.length - 1].split(".");
    const keyString = key?.toString() !== "base" ? `${startCase(key)} ` : "";
    return `${keyString}${detail}`;
  });
  return errors;
};

export const handleError = (error, toastId) => {
  const errors = formatErrors(error?.response?.data);
  if (errors.length) {
    errors.forEach((err, index) =>
      showErrorToast({
        message: err,
        config: { toastId: `${toastId}-${index}` },
      }),
    );
  }
  throw error;
};

export const handle401 = (error) => {
  if (error.response && error.response.status === 401) {
    showErrorToast({ message: "You are not authorized to perform this action" });
  }

  return Promise.reject(error);
};
